import axios from "axios";
import { rootUrl } from "../rootUrl";

export const adminLogin = async (password: string): Promise<{ accessToken: string }> => {
  const { data } = await axios.post(`${rootUrl}/admin/login`, { password });
  return data;
};

export const verifyAdminToken = async (token: string): Promise<{ valid: boolean }> => {
  const { data } = await axios.get(`${rootUrl}/admin/verify`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};
